<div *ngIf="loading$ | async; else scorecard">
  <glxy-loading-spinner [size]="'small'"></glxy-loading-spinner>
</div>

<ng-template #scorecard>
  <div *ngIf="snapshotId$ | async; else emptyState">
    <snap-scorecard
      [businessId]="accountGroupId$ | async"
      [partnerId]="partnerId"
      [trackingCategory]="trackingCategory"
      [snapshotName]="snapshotName"
      [showEditButton]="hasEditAccess$ | async"
    ></snap-scorecard>
  </div>
</ng-template>

<ng-template #emptyState>
  <div class="main-content">
    <glxy-empty-state>
      <glxy-empty-state-hero>
        <img [src]="emptyStateImage" />
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{ 'SNAPSHOT_REPORT.EMPTY_STATE.TITLE' | translate : { snapshotName } }}
      </glxy-empty-state-title>
      <p>{{ 'SNAPSHOT_REPORT.EMPTY_STATE.DESCRIPTION' | translate }}</p>
      <glxy-empty-state-actions>
        <div class="create-button">
          <ng-container *ngIf="createButtonLoading$ | async; else createSnapshotEnabledButton">
            <button mat-flat-button color="primary" disabled>
              <glxy-loading-spinner size="small"></glxy-loading-spinner>
            </button>
          </ng-container>
        </div>
      </glxy-empty-state-actions>
    </glxy-empty-state>
  </div>
</ng-template>

<ng-template #createSnapshotEnabledButton>
  <button mat-flat-button color="primary" (click)="createSnapshotClicked()">
    {{ 'SNAPSHOT_REPORT.ACTION.CREATE' | translate : { snapshotName } }}
  </button>
</ng-template>
